
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { addCountryCode, updateCountryCode } from "@/api/api-basic";
import i18n from "@/config/i18n";
import regular from "@/common/regular";
@Component
export default class SystemConfigRoleInfo extends Vue {
  private ruleInline: objAny = {
    countryCode: [
      {
        required: true,
        validator: regular.int,
        trigger: "blur",
        name: i18n.t("countrycode.areaCode")
      }
    ],
    englishCodeName: [
      {
        required: true,
        validator: regular.name,
        trigger: "blur",
        max: 200,
        name: i18n.t("countrycode.enName")
      }
    ],
    chineseCodeName: [
      {
        required: true,
        validator: regular.name,
        trigger: "blur",
        max: 200,
        name: i18n.t("countrycode.zhName")
      }
    ],
    localLanguageCodeName: [
      {
        required: true,
        validator: regular.name,
        trigger: "blur",
        max: 200,
        name: i18n.t("countrycode.locName")
      }
    ],
    regularExpression: [
      {
        required: true,
        validator: (rule: objAny, value: any, callback: any) => {
          if (!value) {
            callback(new Error(i18n.t("countrycode.regRulesPl") + ""));
          }
          // else if (!this.isRegExp(value)) {
          //   callback(new Error(i18n.t("countrycode.regRulesPl1") + ""));
          // }
          else {
            callback();
          }
        },
        trigger: "blur",
        max: 100
      }
    ]
  };
  // private isRegExp(str: any) {
  //   try {
  //     new RegExp(str);
  //     return true;
  //   } catch (e) {
  //     return false;
  //   }
  // }
  private formItem: objAny = {
    countryCode: "",
    pkId: "",
    englishCodeName: "",
    chineseCodeName: "",
    localLanguageCodeName: "",
    regularExpression: ""
  };
  private FormData: objAny = {};
  private loading = false;

  public initData(data: objAny): void {
    this.handleReset();
    this.formItem = { ...data };
  }

  public handleSubmit(): void {
    this.FormData.validate((valid: boolean) => {
      if (valid) {
        this.submitData();
      }
    });
  }

  public handleReset() {
    if (this.FormData) {
      this.FormData.resetFields();
    }
  }
  async submitData(): Promise<void> {
    this.loading = true;

    const ret = await (this.formItem.pkId ? updateCountryCode : addCountryCode)(
      this.formItem
    );
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("operationSucess") + "");
      this.$emit("success");
    }
    this.loading = false;
  }

  mounted() {
    this.$nextTick((): void => {
      this.FormData = this.$refs["formInline"];
    });
  }
}
